import React, { useEffect, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import connectOptions, { mergeProps } from '../../utils/connectOptions';

import ContactTarget from '../../components/Contact/ContactTarget';
import { loadContactTarget } from '../../actions/contact/contactTarget';

import config from '../../config';

const columns = config.tables.getIn(['contactTarget', 'columns']);

/**
 * ContactTargets tab container.
 */
const ContactTargetContainer = ({ match, targetsState, loadContactTarget, ...rest }) => {
  useEffect(() => {
    const { contactId } = match.params;

    loadContactTarget({ id: contactId });
  }, []);

  /**
   * On table row DoubleClick open company page.
   *
   * @param e {React.SyntheticEvent}.
   * @param index {Number} Row indexs.
   */
  const handleDoubleClick = useCallback(
    (event, index) => {
      const companyId = targetsState.getIn(['targets', index, 'entityId']);

      window.open(`/company/${companyId}`);
    },
    [targetsState],
  );

  const loading = targetsState.get('loading');
  const targets = targetsState.get('targets');

  return <ContactTarget {...rest} loading={loading} onDoubleClick={handleDoubleClick} targets={targets} />;
};

function mapStateToProps(state) {
  return {
    targetsState: state.contact.targets,
    columns,
  };
}

ContactTargetContainer.propTypes = {
  columns: PropTypes.instanceOf(List).isRequired,
  loadContactTarget: PropTypes.func.isRequired,
  targetsState: PropTypes.instanceOf(Map).isRequired,
};

export { ContactTargetContainer };
export default connect(
  mapStateToProps,
  { loadContactTarget },
  mergeProps,
  connectOptions,
)(memo(ContactTargetContainer));
